const toTimeOnlyString = (timeValue) => {
  const time = new Date(timeValue)

  return time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
}

export default toTimeOnlyString
